import { IntegrationConnection } from "@common/types/integrationConnection";

export const getQuickbooksConnectionLabel = (
    connection: IntegrationConnection,
) => connection.label ?? "QuickBooks company";
